import React from 'react'
import { useTranslation } from 'react-i18next'

import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import Stack from '@mui/material/Stack'

import { MachineSlot } from '../../types/machineslot'
import ProfileTypeChip from './profileTypeChip'

interface SlotAssignmentReplaceProps {
  assignedSlots: Array<MachineSlot>
  newProfileName: string
  onClose: () => void
  onReplace: (slotToReplaceUrl: string) => void
}

const SlotAssignmentReplace = (props: SlotAssignmentReplaceProps): JSX.Element => {
  const { t } = useTranslation()

  const [selectedMachineSlotUrl, setSelectedMachineSlotUrl] = React.useState<string>('')

  return (
    <Dialog open={true} onClose={props.onClose} onKeyDown={(e) => e.stopPropagation()}>
      <DialogTitle>{t('profilesview.replaceassignedslot')}</DialogTitle>
      <DialogContent>
        <Typography>{t('profilesview.replaceslotinfo').replace('{0}', props.newProfileName)}"</Typography>
        <FormControl sx={{ mt: 3 }}>
          <FormLabel>{t('profilesview.selectslottoreplace')}</FormLabel>
          <RadioGroup
            name="slot-replace-group"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSelectedMachineSlotUrl(event.target.value)}
          >
            {props.assignedSlots.map((x) => {
              return (
                <FormControlLabel
                  key={x.url}
                  sx={{ mt: 1 }}
                  value={x.url}
                  control={<Radio />}
                  label={
                    <Stack direction={{ xs: 'column', md: 'row' }} alignItems="flex-start">
                      <Typography sx={{ mr: 2 }}>{x.requested_profile_data?.name}</Typography>
                      {x.requested_profile_data && <ProfileTypeChip profile={x.requested_profile_data} />}
                    </Stack>
                  }
                />
              )
            })}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>{t('common.cancel')}</Button>
        <Button
          variant="contained"
          disabled={!selectedMachineSlotUrl}
          onClick={(): void => props.onReplace(selectedMachineSlotUrl)}
        >
          {t('profilesview.replaceslot')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SlotAssignmentReplace
